import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import 'devextreme/data/odata/store';
import DataGrid, {
  Column,
  Editing,
  Paging,
  SearchPanel,
  FilterRow,
  HeaderFilter,
  GroupPanel,
  Export,
  ColumnChooser,
  Pager,
  Scrolling,
  Summary,
  TotalItem,
  LoadPanel,
  Toolbar,
  StateStoring,
  FilterPanel,
  Selection,
  Lookup,
} from 'devextreme-react/data-grid';
import { Item, RequiredRule } from 'devextreme-react/form';
import './bookingInvoices.scss';
import axios from 'axios';
import dxDataGrid from 'devextreme/ui/data_grid';
import { useNavigate } from 'react-router-dom';
import notify from 'devextreme/ui/notify';

export default function BookingInvoices(bookingId: any) {
  
  const baseUrl = process.env.REACT_APP_API_URL;
  const [invoices, setInvoices] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [invoiceStatuses, setInvoiceStatuses] = useState<any[]>([]);

  const navigate = useNavigate();

  const bookingInvoicesGridRef = useRef<dxDataGrid>(null);

  useEffect(() => {
    getInvoices();
    getInvoiceStatuses();
  }, []);

  const getInvoices = () => {
    if (typeof bookingId.bookingId !== 'number' || isNaN(bookingId.bookingId)) {
      // console.error('Invalid bookingId:', bookingId.bookingId);
      return;
    }

    setLoading(true);
    axios.get(`${baseUrl}/api/Booking/bookingInvoices?bookingId=${bookingId.bookingId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`
      }
    })
      .then(response => setInvoices(response.data.data))
      .catch(error => console.error('Error fetching invoices:', error))
      .finally(() => setLoading(false));
  };

  const getInvoiceStatuses = () => {
    setLoading(true);
    axios.get(`${baseUrl}/api/StaticData/invoiceStatuses`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`
      }
    })
      .then(response => setInvoiceStatuses(response.data.data))
      .catch(error => console.error('Error fetching statuses:', error))
      .finally(() => setLoading(false));
  };

  const onInitialized = useCallback((e: any) => {
    bookingInvoicesGridRef.current = e.component;
  }, []);

  const onSaving = async(e: any) => {
    const change = e.changes?.[0];
    if (!change) return;
  
    const grid = e.component;
    const rowIndex = grid.getRowIndexByKey(change.key);
    const rowData = grid.getDataSource().items()[rowIndex];
  
    const invoiceNumber = rowData.invoiceNumber;
    const invoiceStatusName = change.data?.invoiceStatus?.name ?? rowData.invoiceStatus?.name;
    const invoiceStatusId = invoiceStatuses.find((invoiceStatus) => invoiceStatus.name === invoiceStatusName)?.id;
  
    try {
      await axios.put(`${baseUrl}/api/Booking/UpdateInvoiceStatus?invoiceNumber=${invoiceNumber}&invoiceStatusId=${invoiceStatusId}`, null, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('authToken')}`
        }
      }).then(() => toast('Rechnungstatus erfolgreich gespeichert', 'success'))
      .catch(error => console.error('Rechnungstatus nicht erfolgreich gespeichert', error));   
    } catch (e: any) {
      console.error(e);
      toast('Rechnungstatus nicht erfolgreich gespeichert', e);
    }
  };

  const toast = useCallback((message: any, type: any = 'success') => {
    notify({ message: message }, type, 3000);
  }, []);

  return (
    <React.Fragment>       
      {/* <h2>Rechnungen </h2> */}
      <DataGrid
        className={'dx-card content-block dx-datagrid-compact'}
        dataSource={invoices}
        keyExpr="id"
        focusedRowEnabled={true}
        defaultFocusedRowIndex={0}
        showBorders={true}
        columnAutoWidth={true}
        allowColumnReordering={true}
        allowColumnResizing={true}
        columnResizingMode="widget"
        showColumnLines={true}
        showRowLines={true}
        rowAlternationEnabled={true}
        columnHidingEnabled={true}
        onInitialized={onInitialized}
        onSaving={onSaving}
        repaintChangesOnly={true}>
        <LoadPanel enabled={true} showIndicator={loading}/>
        {/* <SearchPanel visible={true} width={240} placeholder="Search..." /> */}
        {/* <FilterRow visible={true} /> */}
        {/* <HeaderFilter visible={true} /> */}
        {/* <GroupPanel visible={false} /> */}
        {/* <ColumnChooser enabled={true} mode='select' height={'600'}/> */}
        {/* <StateStoring enabled={true} type="localStorage" storageKey="innkepBookingGridState" /> */}
        {/* <FilterPanel visible={true} /> */}
        {/* <Selection mode="multiple" showCheckBoxesMode="always" /> */}
        {/* <Toolbar>       
          <Item name="searchPanel" />
        </Toolbar> */}
        {/* <Paging defaultPageSize={10} />
        <Pager
          showPageSizeSelector={true}
          allowedPageSizes={[10, 20, 50]}
          showInfo={true}
        /> */}
        {/* <Summary>
            <TotalItem column="Id" summaryType="count" />
        </Summary> */}
        <Editing
          refreshMode={'repaint'}
          mode="row"
          useIcons={true}
          allowUpdating={true}
          allowDeleting={false}
          allowAdding={false}
          texts={{ confirmDeleteMessage: '' }}>
        </Editing>
        {/* <FilterRow visible={true} /> */}
        {/* <Scrolling mode="standard" /> */}
        <Scrolling useNative={true} showScrollbar="always" />

        <Column dataField="id" sortIndex={0} sortOrder="asc" visible={false} allowEditing={false}/>
        <Column dataField="invoiceNumber" caption="Rechnungsnummer" allowEditing={false}/> 
        <Column dataField="type" caption="Typ" allowEditing={false}
          calculateCellValue={(data: any) => ((data.price >= 0) ? `Rechnung` : `Stornorechnung`)}
        />  
        <Column dataField="price" caption="Preis" allowEditing={false}/>
        <Column dataField="invoiceStatus.name" caption="Status" allowEditing={true}>  
          <Lookup dataSource={invoiceStatuses} displayExpr="name" valueExpr="name" />
        </Column>
        <Column dataField="refInvoiceNumber" caption="Referenzrechnungsnummer" visible={false} allowEditing={false}/>  
        <Column dataField="createdDate" caption="Erstellet am" dataType="date" format="dd.MM.yyyy" allowEditing={false}/>
        <Column dataField="updatedDate" caption="Aktualisiert am" dataType="date" format="dd.MM.yyyy" allowEditing={false} />
      </DataGrid>      
    </React.Fragment>
)}